
import './styles/quasar.scss'
import lang from 'quasar/lang/es.js'
import '@quasar/extras/material-icons/material-icons.css'
import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js';import AddressbarColor from 'quasar/src/plugins/AddressbarColor.js'; 

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    addressbarColor: '#e42020'
  },
  plugins: {
    Notify,
    Dialog,
    Loading,
    AddressbarColor
  },
  lang: lang
}